export default class CorePagamentoService {
    CorePagamento;
    CoreDepartamento;
    CoreFormaPagamento;
    constructor(CorePagamento, CoreDepartamento, CoreFormaPagamento) {
        this.CorePagamento = CorePagamento;
        this.CoreDepartamento = CoreDepartamento;
        this.CoreFormaPagamento = CoreFormaPagamento;
    }
    table(query) {
        return this.CorePagamento.table(query).$promise;
    }
    options() {
        return this.CorePagamento.options().$promise;
    }
    getDepartamentos() {
        return this.CoreDepartamento.find().$promise;
    }
    getFormasPagamento() {
        return this.CoreFormaPagamento.find().$promise;
    }
}
CorePagamentoService.$inject = ['CorePagamento', 'CoreDepartamento', 'CoreFormaPagamento'];
